import './fieldText.css'
import React from "react";
import img_immatriculation from '../../img/immatriculation.png'

export default class FieldText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: props.container.devis.params[props.field] || '',
            isFocused: false // The "Lock"
        };
        
        this.ref = React.createRef();
        this.sendTimeout = false
    }

    persistData = (value) => {
        const { changeParams } = this.props.container;
        const { field } = this.props;
        changeParams({ [field]: value });
    }

    componentDidUpdate(prevProps) {
        const newValue = this.props.container.devis.params[this.props.field] || '';
        const prevValue = prevProps.container.devis.params[this.props.field] || '';

        // ONLY sync props to state if:
        // 1. The value from the server actually changed
        // 2. The user is NOT currently typing (isFocused is false)
        if (newValue !== prevValue && !this.state.isFocused) {
            this.setState({ current: newValue });
        }
    }

    handleChange = (e) => {
        const { updater, field } = this.props;
        const storer = this.props.container.devis.getStorer(field);
        
        const rawValue = e.target.value;
        const value = updater ? updater(rawValue) : rawValue;
        const storedValue = storer(value);

        // 1. Update UI immediately
        this.setState({ current: storedValue });
        
        // 2. Schedule server sync
        if (this.sendTimeout) clearTimeout(this.sendTimeout);

        // 2. Start a fresh one
        this.sendTimeout = setTimeout(() => {
            this.persistData(storedValue);
        }, 500);
    }

    render() {
        const { devis, showValidate, focusError } = this.props.container;
        const { field, notice, noCheck, placeholder, logo, logoClass } = this.props;
        const displayer = devis.getDisplayer(field);
        
        let message = devis.validateMessage(field);
        if (message && !noCheck) focusError(this.ref);
        if (noCheck || !showValidate) message = undefined;

        const label = this.props.label || devis.getLabel(field);

        return (
            <>
                <h3>{label}</h3>
                {notice && <span className="notice">{notice}</span>}
                <div ref={this.ref} className={'front_form_row' + (message ? ' invalidbox' : '')}>
                    {logo && <img src={logo} className={logoClass ? ('logo ' + logoClass) : 'logo'} alt="icon" />}
                    <input 
                        className={logo ? 'text_input with_logo' : 'text_input'} 
                        type="text" 
                        value={displayer(this.state.current)} 
                        placeholder={placeholder}
                        onFocus={() => this.setState({ isFocused: true })}
                        onBlur={() => {
                            this.setState({ isFocused: false });
                            // Optional: Force a final sync on blur to ensure data safety
                            this.persistData(this.state.current);
                        }}
                        onChange={this.handleChange}
                    />
                </div>
                {message && <div className="invalid">{message}</div>}
            </>
        );
    }
}